import {
  Box,
  Tooltip,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography
} from '@mui/material'
import React, { useState, MouseEvent } from 'react'
import { UserActions } from '../state/user'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'

const settings = ['Profile']

interface UserMenuProps {
  username: string
}

export const UserMenu = ({ username }: UserMenuProps): JSX.Element => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null)

  const handleOpenUserMenu = (event: MouseEvent<HTMLElement>): void => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = (): void => {
    setAnchorElUser(null)
  }

  const handleOpenPage = (option: string): void => {
    navigate(option)
  }

  const handleLogout = (): void => {
    localStorage.removeItem('MyPath-username')
    localStorage.removeItem('MyPath-password')
    localStorage.removeItem('MyPath-jwtToken')
    localStorage.removeItem('MyPath-googleToken')
    dispatch(UserActions.reset())
  }

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title='Open settings'>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar alt='User name'>{username[0]}</Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {settings.map(setting => (
          <MenuItem
            key={setting}
            onClick={() => {
              handleCloseUserMenu()
              handleOpenPage(setting)
            }}
          >
            <Typography textAlign='center'>{setting}</Typography>
          </MenuItem>
        ))}
        {/* <a
          href='https://jan-mat.pl/'
          style={{ color: 'black', textDecoration: 'none' }}
        >
          <MenuItem key={'Jan-Mat'}>
            {' '}
            <Typography textAlign='center'>{'Jan-Mat'}</Typography>
          </MenuItem>
        </a> */}
        <MenuItem
          key='Logout'
          onClick={() => {
            handleCloseUserMenu()
            handleLogout()
          }}
        >
          <Typography textAlign='center'>Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  )
}
